<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-card elevation="0">
                                <v-card-text class="d-flex flex-column ga-1">
                                    <div>Faculty Name: <span class="font-weight-bold">{{ getItemTitle(mentoringData.faculty) }}</span></div>
                                    <div>Mentoring Date: <span class="font-weight-bold">{{ formatDate(mentoringData.mentoring_date) }}</span></div>
                                    <div>Office: <span class="font-weight-bold">{{ mentoringData.office.name }}</span></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col class="text-right mt-md-10" cols="12" md="6">
                            <v-btn
                            v-if="data.length > 0"
                            @click="printMentoring()"
                            prepend-icon="mdi-printer"
                            class="mt-1 rounded-lg"
                            color="deep-orange-darken-1"
                            height="40px"
                            elevation="2">
                                Print Mentoring
                            </v-btn>
                            <v-btn
                                @click="showAddDialog()"
                                prepend-icon="mdi-plus"
                                class="mt-1 rounded-lg ml-md-2"
                                color="routesColor"
                                height="40px"
                                elevation="2">
                                Add Mentoring Details
                            </v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-card class="dt-container">    
                                <v-data-table
                                    :mobile="isMobileOrTablet()"
                                    :headers="headers"
                                    :items="data"
                                    :loading="loading"
                                    :items-per-page="15"
                                    :items-per-page-options="[15,30, 50, 100, -1]"
                                >
                                <template v-slot:loading>
                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                </template>
                                <template v-slot:item.found_date="{ item }">
                                    <span>{{ formatDate(item.found_date) }} </span>
                                </template>
                                <template v-slot:[`item.action`]="{ item }">
                                    <div class="d-flex justify-end ga-2">
                                        <v-btn @click="showEditDialog(item)" size="x-small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                                        <v-btn  @click="showDeleteDialog(item)" size="x-small" variant="outlined" text="Remove" color="red" elevation="3"></v-btn>
                                    </div>
                                </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDel" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to remove this mentoring details?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible..</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDel = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteMentoringDetail()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <mentoring-details-sub-dialog ref="mentoringDetailsSubDialog" @refresh="initView(mentoringData)"></mentoring-details-sub-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import MentoringDetailsSubDialog from './Sub-Dialogs/MentoringDetailsSubDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar';
import { generateMentoringPDF } from '@/composables/pdf/mentoring-pdf.js';

export default defineComponent({
     emits: ["refresh"],
     components: {
        MentoringDetailsSubDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,
            headers: [
                { title: 'Concern', align: 'start', sortable: true, key: 'concern' },
                { title: 'Date Identified', align: 'start', sortable: true, key: 'found_date' },
                { title: 'Coaching/Mentoring Description/Recommendation', align: 'start', sortable: true, key: 'recommendation' },
                { title: 'Faculty Commitment', align: 'start', sortable: true, key: 'commitment' },
                { title: 'Timeline', align: 'start', sortable: true, key: 'timeline' },
                { title: 'Remarks/Date', align: 'start', sortable: true, key: 'remarks' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            data: [],
            mentoringData: [],
            confirmDel: false,
            toBeDeletedItem: null,
        }
     },
     methods: {
        initView(data){
            this.dialog = true
            this.dialog_title = 'View Mentoring'
            this.dialog_sub_title = 'View mentoring information'
            this.action = 'view'

            this.mentoringData = data
            this.initDetails()
        },
        async initDetails(){
            let res = await this.axiosCall('/mentoring-details/findAllByMentoring/' + this.mentoringData.id, 'get', null, true)
            if(res.data){
                this.data = res.data
            }
        },
        async deleteMentoringDetail(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let res = await this.axiosCall('/mentoring-details/' + this.toBeDeletedItem.id, 'delete', null, true)
            if(res.data){
                showSnackbar('Mentoring details successfully removed.')
                this.initDetails()
            }
            this.loading = false
            this.confirmDel = false
        },
        getItemTitle(item) {
            return `${item.fname} ${item.mname ? item.mname[0] + '.' :''} ${item.lname}${item.suffix ? ', ' + item.suffix : ''}` ;
        },
        showAddDialog(){
            this.$refs.mentoringDetailsSubDialog.initAdd(this.mentoringData)
        },
        showEditDialog(item){
            this.$refs.mentoringDetailsSubDialog.initUpdate(item)
        },
        showDeleteDialog(item){
            this.toBeDeletedItem = item
            this.confirmDel = true
        },
        printMentoring(){
            generateMentoringPDF(this.mentoringData, this.data, this.$store.state.user.office.name)
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>